(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.announcement-bar__item'));
      this.prevButton = this.querySelector('.announcement-bar__nav--prev');
      this.nextButton = this.querySelector('.announcement-bar__nav--next');
      this.autoplay = this.dataset.autoplay === 'true';
      this.interval = parseInt(this.dataset.interval, 10) || 5000;
      this.timer = null;

      if (!this.items.length) return;

      const activeIndex = this.items.findIndex((item) => item.classList.contains('is-active'));
      this.index = activeIndex === -1 ? 0 : activeIndex;
      this.items[this.index].classList.add('is-active');

      this.prevButton?.addEventListener('click', () => this.go(this.index - 1));
      this.nextButton?.addEventListener('click', () => this.go(this.index + 1));

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    go(newIndex) {
      if (!this.items.length) return;
      this.items[this.index].classList.remove('is-active');
      this.index = (newIndex + this.items.length) % this.items.length;
      this.items[this.index].classList.add('is-active');
    }

    start() {
      if (!this.autoplay || this.items.length < 2 || this.timer) return;
      this.timer = window.setInterval(() => this.go(this.index + 1), this.interval);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }
  }

  if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.triggers = document.querySelectorAll('[data-cart-drawer-trigger]');
      this.closers = this.querySelectorAll('[data-cart-drawer-close]');

      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        });
      });

      this.closers.forEach((closer) => closer.addEventListener('click', () => this.close()));

      this.addEventListener('click', (event) => {
        const removeBtn = event.target.closest('[data-cart-quantity-remove]');
        const changeBtn = event.target.closest('[data-cart-quantity-change]');

        if (removeBtn) {
          this.updateLine(removeBtn.dataset.line, 0);
        } else if (changeBtn) {
          const row = changeBtn.closest('.cart-drawer__item');
          const valueEl = row.querySelector('.cart-drawer__quantity-value');
          const current = parseInt(valueEl.textContent, 10) || 0;
          const next = Math.max(0, current + parseInt(changeBtn.dataset.cartQuantityChange, 10));
          this.updateLine(changeBtn.dataset.line, next);
        }
      });

      document.addEventListener('cart:open', () => this.open());
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });
    }

    updateLine(line, quantity) {
      this.classList.add('is-loading');
      Theme.cart
        .change(line, quantity)
        .catch(() => {})
        .finally(() => this.classList.remove('is-loading'));
    }

    open() {
      this.removeAttribute('hidden');
      window.requestAnimationFrame(() => this.classList.add('is-open'));
      document.body.style.overflow = 'hidden';
    }

    close() {
      this.classList.remove('is-open');
      document.body.style.overflow = '';
      window.setTimeout(() => this.setAttribute('hidden', ''), 250);
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.querySelectorAll('[data-cart-page-decrease], [data-cart-page-increase]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('.quantity-selector__input');
      const delta = button.hasAttribute('data-cart-page-increase') ? 1 : -1;
      input.value = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  /**
   * Clamps a long collection description to a readable height with a
   * "Show more" toggle. The toggle stays hidden unless the content actually
   * overflows the clamp (measured after layout), so short descriptions never
   * show a button that would do nothing.
   */
  class CollectionDescription extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-description]');
      this.toggleButton = this.querySelector('[data-description-toggle]');
      this.label = this.querySelector('[data-toggle-label]');
      if (!this.content || !this.toggleButton) return;

      window.requestAnimationFrame(() => {
        if (this.content.scrollHeight > this.content.clientHeight + 4) {
          this.toggleButton.hidden = false;
          // Gates the bottom fade-out in CSS -- only shown when there is
          // actually more content below it to reveal.
          this.classList.add('has-overflow');
        }
      });

      this.toggleButton.addEventListener('click', () => this.toggle());
    }

    toggle() {
      const expanding = !this.classList.contains('is-expanded');
      // Set an explicit pixel height (rather than jumping straight to
      // "none") so the max-height transition actually animates instead of
      // snapping open/shut.
      this.style.setProperty('--description-expanded-height', `${this.content.scrollHeight}px`);
      this.classList.toggle('is-expanded', expanding);
      this.toggleButton.setAttribute('aria-expanded', String(expanding));
      this.label.textContent = expanding ? this.toggleButton.dataset.showLess : this.toggleButton.dataset.showMore;
    }
  }

  if (!customElements.get('collection-description')) {
    customElements.define('collection-description', CollectionDescription);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /**
   * Local, self-contained debounce — deliberately not the shared
   * Theme.debounce helper from assets/theme.js. That asset loads via a
   * <script defer> at the very end of <body>, while this section's own
   * compiled script can run earlier (via content_for_header in <head>).
   * If Theme isn't defined yet when this runs, `Theme.debounce(...)` throws,
   * which aborts the rest of connectedCallback() before it reaches the
   * search-toggle click listener below — the search icon looks dead because
   * no listener was ever attached, not because of anything CSS-related.
   */
  function debounce(fn, wait) {
    let timeout;
    return function debounced(...args) {
      window.clearTimeout(timeout);
      timeout = window.setTimeout(() => fn.apply(this, args), wait);
    };
  }

  const CLOSE_DELAY_MS = 200;

  class SiteHeader extends HTMLElement {
    connectedCallback() {
      this.condense = this.dataset.condense === 'true';
      this.searchToggle = this.querySelector('[data-search-toggle]');
      this.searchClose = this.querySelector('[data-search-close]');
      this.searchPanel = this.querySelector('[data-search-panel]');
      this.searchOverlay = this.querySelector('[data-search-overlay]') || document.querySelector('[data-search-overlay]');
      this.searchInput = this.querySelector('[data-predictive-search-input]');
      this.searchResults = this.querySelector('[data-predictive-search-results]');
      this.searchEmptyState = this.querySelector('[data-search-empty-state]');
      this.dropdownItems = Array.from(this.querySelectorAll('.site-header__nav-item.has-dropdown'));
      this.closeTimer = null;

      if (this.searchInput && this.searchResults) {
        this.searchInput.addEventListener('input', debounce(() => this.runPredictiveSearch(), 250));
      }

      // Popular-search chips (shown only while the box is empty) fill the
      // input with their own text and immediately run the same predictive
      // search a real typed query would, rather than linking anywhere --
      // clicking one should behave exactly like typing it.
      this.querySelectorAll('[data-search-suggestion]').forEach((chip) => {
        chip.addEventListener('click', () => {
          this.searchInput.value = chip.textContent.trim();
          this.searchInput.focus();
          this.runPredictiveSearch();
        });
      });

      if (this.condense) {
        this.onScroll = debounce(() => {
          this.classList.toggle('is-condensed', window.scrollY > 40);
        }, 10);
        window.addEventListener('scroll', this.onScroll, { passive: true });
      }

      this.searchToggle?.addEventListener('click', () => this.toggleSearch());
      this.searchClose?.addEventListener('click', () => this.toggleSearch(false));
      this.searchOverlay?.addEventListener('click', () => this.toggleSearch(false));

      /*
       * Contextual per-category flyout:
       * - The category <a> is a plain link with no click handler at all, so
       *   it always navigates on click/Enter regardless of hover state.
       * - Hovering the <li> opens ONLY that item's own panel immediately.
       *   This row is only visible at >=990px anyway (the mobile accordion
       *   takes over below that), so any pointer able to fire mouseenter
       *   here is treated as real hover -- no touch-capability gating.
       * - Leaving the <li> starts a ~200ms close timer instead of closing
       *   immediately, so briefly crossing the small gap between the link
       *   and its panel (or moving slightly off target) doesn't flicker the
       *   menu shut. Re-entering the same item (or moving into the panel,
       *   which is a DOM descendant of the <li>) cancels the pending close.
       * - :focus-within in CSS handles keyboard Tab access independently of
       *   this JS, so opening still works even with JS disabled.
       */
      this.dropdownItems.forEach((item) => {
        const link = item.querySelector(':scope > .site-header__nav-link');

        /*
         * No matchMedia('(hover: hover)') gate here (an earlier version had
         * one, gating open/close on it). That query reports `false` on any
         * device Chromium considers touch-capable -- including hybrid
         * touchscreen laptops that are actually being driven with a mouse
         * or trackpad, and an iPad in landscape width (>=990px, wide enough
         * that this desktop nav row is the one showing, not the mobile
         * accordion). On those devices the gate silently discarded every
         * mouseenter/mouseleave, so hovering did nothing at all -- confirmed
         * live with a touch-capable browser profile before removing it.
         * mouseenter/mouseleave only fire from an actual pointer moving
         * over the element in the first place, so no extra gating is
         * needed: a touch tap fires its own click/navigation, not a
         * lingering hover state.
         */
        /*
         * Entering a new item closes every OTHER item immediately (not via
         * the delayed timer -- that delay exists only for the "mouse left
         * the nav entirely" case). A single shared `this.closeTimer` used to
         * back this: leaving item A started A's close timer, then entering
         * item B immediately cleared that same shared timer to cancel its
         * own close, which also cancelled A's pending close as a side
         * effect -- so quickly moving the pointer from one category to the
         * next left the FIRST one's panel open forever (confirmed visually:
         * two panels rendered on screen at once, e.g. Racquets and Apparel
         * both open simultaneously). Closing all other items up front on
         * every mouseenter/focusin makes this impossible regardless of
         * timer timing.
         */
        item.addEventListener('mouseenter', () => {
          window.clearTimeout(this.closeTimer);
          this.dropdownItems.forEach((other) => {
            if (other !== item) this.closeItem(other, other.querySelector(':scope > .site-header__nav-link'));
          });
          this.openItem(item, link);
        });

        item.addEventListener('mouseleave', () => {
          window.clearTimeout(this.closeTimer);
          this.closeTimer = window.setTimeout(() => this.closeItem(item, link), CLOSE_DELAY_MS);
        });

        item.addEventListener('focusin', () => {
          window.clearTimeout(this.closeTimer);
          this.dropdownItems.forEach((other) => {
            if (other !== item) this.closeItem(other, other.querySelector(':scope > .site-header__nav-link'));
          });
          this.openItem(item, link);
        });
      });

      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.closeAllDropdowns();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          const openItem = this.dropdownItems.find((i) => i.classList.contains('is-open'));
          this.closeAllDropdowns();
          openItem?.querySelector('.site-header__nav-link')?.focus();
          this.toggleSearch(false);
        }
      });

      // Keyboard users tabbing away from an open panel (to a different
      // top-level item, or out of the nav entirely) should close it.
      this.addEventListener(
        'focusout',
        debounce(() => {
          this.dropdownItems.forEach((item) => {
            if (!item.contains(document.activeElement)) {
              this.closeItem(item, item.querySelector('.site-header__nav-link'));
            }
          });
        }, 0),
      );
    }

    openItem(item, link) {
      item.classList.add('is-open');
      link?.setAttribute('aria-expanded', 'true');
    }

    closeItem(item, link) {
      item.classList.remove('is-open');
      link?.setAttribute('aria-expanded', 'false');
    }

    closeAllDropdowns() {
      window.clearTimeout(this.closeTimer);
      this.dropdownItems.forEach((item) => this.closeItem(item, item.querySelector('.site-header__nav-link')));
    }

    async runPredictiveSearch() {
      const term = this.searchInput.value.trim();

      if (term.length < 2) {
        // Empty (or 1-character) box: hide any stale results and go back to
        // showing the popular-searches / recommended-products state instead
        // of leaving the panel blank.
        this.searchResults.setAttribute('hidden', '');
        this.searchResults.innerHTML = '';
        this.searchEmptyState?.removeAttribute('hidden');
        return;
      }

      this.searchEmptyState?.setAttribute('hidden', '');

      const baseUrl = this.searchInput.dataset.predictiveSearchUrl;
      const url = `${baseUrl}?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`;

      try {
        const response = await fetch(url);
        const html = await response.text();
        this.searchResults.innerHTML = html;
        this.searchResults.removeAttribute('hidden');
      } catch (error) {
        this.searchResults.setAttribute('hidden', '');
        this.searchEmptyState?.removeAttribute('hidden');
      }
    }

    toggleSearch(force) {
      const shouldOpen = force !== undefined ? force : this.searchPanel.hasAttribute('hidden');
      this.searchToggle.setAttribute('aria-expanded', String(shouldOpen));
      if (shouldOpen) {
        this.searchPanel.removeAttribute('hidden');
        this.searchOverlay?.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
        window.requestAnimationFrame(() => this.searchInput?.focus());
      } else {
        this.searchPanel.setAttribute('hidden', '');
        this.searchOverlay?.setAttribute('hidden', '');
        document.body.style.overflow = '';
      }
    }
  }

  if (!customElements.get('site-header')) {
    customElements.define('site-header', SiteHeader);
  }

  class MobileMenu extends HTMLElement {
    connectedCallback() {
      this.triggers = document.querySelectorAll('[data-mobile-menu-toggle]');
      this.closers = this.querySelectorAll('[data-mobile-menu-close]');
      this.accordions = Array.from(this.querySelectorAll('[data-mobile-accordion]'));

      this.triggers.forEach((trigger) => trigger.addEventListener('click', () => this.open()));
      this.closers.forEach((closer) => closer.addEventListener('click', () => this.close()));

      // Only one category expanded at a time: closing the others when one
      // opens. Native <details> doesn't do this on its own across the
      // browser matrix this storefront supports.
      this.accordions.forEach((details) => {
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          this.accordions.forEach((other) => {
            if (other !== details) other.open = false;
          });
        });
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });
    }

    open() {
      this.removeAttribute('hidden');
      window.requestAnimationFrame(() => this.classList.add('is-open'));
      document.body.style.overflow = 'hidden';
      this.triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'true'));
    }

    close() {
      this.classList.remove('is-open');
      document.body.style.overflow = '';
      this.triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
      window.setTimeout(() => this.setAttribute('hidden', ''), 250);
    }
  }

  if (!customElements.get('mobile-menu')) {
    customElements.define('mobile-menu', MobileMenu);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  class HeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
      this.progressBars = Array.from(this.querySelectorAll('[data-hero-dot]'));
      this.prevButton = this.querySelector('[data-hero-prev]');
      this.nextButton = this.querySelector('[data-hero-next]');
      this.index = Math.max(this.slides.findIndex((slide) => slide.classList.contains('is-active')), 0);
      this.autoplay = this.dataset.autoplay === 'true';
      this.interval = parseInt(this.dataset.interval, 10) || 6000;
      this.timer = null;

      if (this.slides.length < 2) return;

      this.prevButton?.addEventListener('click', () => this.go(this.index - 1));
      this.nextButton?.addEventListener('click', () => this.go(this.index + 1));
      this.progressBars.forEach((bar, i) => bar.addEventListener('click', () => this.go(i)));

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());

      this.addEventListener('touchstart', (event) => this.onTouchStart(event), { passive: true });
      this.addEventListener('touchend', (event) => this.onTouchEnd(event), { passive: true });

      this.setActiveProgress();
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    onTouchStart(event) {
      this.touchStartX = event.changedTouches[0].screenX;
    }

    onTouchEnd(event) {
      const touchEndX = event.changedTouches[0].screenX;
      const delta = touchEndX - this.touchStartX;
      const swipeThreshold = 40;

      if (Math.abs(delta) < swipeThreshold) return;

      if (delta < 0) {
        this.go(this.index + 1);
      } else {
        this.go(this.index - 1);
      }
    }

    go(newIndex) {
      this.slides[this.index].classList.remove('is-active');
      this.index = (newIndex + this.slides.length) % this.slides.length;
      this.slides[this.index].classList.add('is-active');
      this.setActiveProgress();
    }

    setActiveProgress() {
      this.progressBars.forEach((bar, i) => {
        const fill = bar.querySelector('.hero-banner__progress-fill');
        bar.classList.toggle('is-active', i === this.index);
        if (!fill) return;

        fill.classList.remove('is-animating');
        fill.style.animationPlayState = 'running';

        if (i < this.index) {
          fill.style.width = '100%';
        } else if (i > this.index) {
          fill.style.width = '0%';
        } else {
          fill.style.width = this.autoplay ? '0%' : '100%';
          if (this.autoplay) {
            void fill.offsetWidth;
            fill.style.setProperty('--progress-duration', `${this.interval}ms`);
            fill.classList.add('is-animating');
          }
        }
      });
    }

    start() {
      if (!this.autoplay || this.timer) return;
      this.timer = window.setInterval(() => this.go(this.index + 1), this.interval);
      const activeFill = this.progressBars[this.index]?.querySelector('.hero-banner__progress-fill');
      if (activeFill) activeFill.style.animationPlayState = 'running';
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
      const activeFill = this.progressBars[this.index]?.querySelector('.hero-banner__progress-fill');
      if (activeFill) activeFill.style.animationPlayState = 'paused';
    }
  }

  if (!customElements.get('hero-slideshow')) {
    customElements.define('hero-slideshow', HeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductPage extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('#ProductForm') || document.getElementById('ProductForm');
      this.productData = JSON.parse(this.querySelector('[data-product-json]').textContent);
      this.idInput = this.querySelector('[data-product-form-id]');
      this.priceEl = this.querySelector('.product__price');
      this.inventoryEl = this.querySelector('[data-inventory-status]');
      this.addToCartBtn = this.querySelector('[data-add-to-cart-button]');
      this.addToCartText = this.querySelector('[data-add-to-cart-text]');
      this.optionInputs = Array.from(this.querySelectorAll('[data-option-input]'));
      this.thumbnails = Array.from(this.querySelectorAll('[data-thumbnail]'));
      this.mediaItems = Array.from(this.querySelectorAll('[data-product-main-media] [data-media-id]'));
      this.zoomOverlay = this.querySelector('[data-zoom-overlay]');
      this.zoomImage = this.querySelector('[data-zoom-image]');
      this.zoomClose = this.querySelector('[data-zoom-close]');
      this.quantityInput = this.querySelector('[data-quantity-input]');

      this.optionInputs.forEach((input) => {
        input.addEventListener('change', () => this.onOptionChange());
      });

      this.thumbnails.forEach((thumb) => {
        thumb.addEventListener('click', () => this.setActiveMedia(thumb.dataset.mediaId));
      });

      this.querySelectorAll('[data-zoom-trigger]').forEach((trigger) => {
        trigger.addEventListener('click', () => this.openZoom(trigger.dataset.zoomSrc));
      });
      this.zoomClose?.addEventListener('click', () => this.closeZoom());
      this.zoomOverlay?.addEventListener('click', (event) => {
        if (event.target === this.zoomOverlay) this.closeZoom();
      });

      this.querySelector('[data-quantity-decrease]')?.addEventListener('click', () => this.stepQuantity(-1));
      this.querySelector('[data-quantity-increase]')?.addEventListener('click', () => this.stepQuantity(1));

      if (this.form) {
        this.form.addEventListener('submit', (event) => this.onSubmit(event));
      }

      this.stickyBar = document.querySelector('[data-sticky-bar]');
      if (this.stickyBar && this.addToCartBtn) {
        this.observer = new IntersectionObserver(
          (entries) => {
            const isVisible = entries[0].isIntersecting;
            this.stickyBar.classList.toggle('is-visible', !isVisible);
            if (isVisible) {
              this.stickyBar.setAttribute('hidden', '');
            } else {
              this.stickyBar.removeAttribute('hidden');
            }
          },
          { threshold: 0 }
        );
        this.observer.observe(this.addToCartBtn);
      }

      this.updateOptionAvailability();
    }

    stepQuantity(delta) {
      if (!this.quantityInput) return;
      const next = Math.max(1, (parseInt(this.quantityInput.value, 10) || 1) + delta);
      this.quantityInput.value = next;
    }

    setActiveMedia(mediaId) {
      this.mediaItems.forEach((item) => item.classList.toggle('is-active', item.dataset.mediaId === mediaId));
      this.thumbnails.forEach((thumb) => thumb.classList.toggle('is-active', thumb.dataset.mediaId === mediaId));
    }

    openZoom(src) {
      if (!this.zoomOverlay || !src) return;
      this.zoomImage.src = src;
      this.zoomOverlay.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    }

    closeZoom() {
      this.zoomOverlay?.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }

    getSelectedOptions() {
      const optionValues = {};
      this.optionInputs.forEach((input) => {
        if (input.checked) optionValues[input.name] = input.value;
      });
      return Object.keys(optionValues)
        .sort()
        .map((key) => optionValues[key]);
    }

    findMatchingVariant(selectedOptions) {
      return this.productData.variants.find((variant) =>
        variant.options.every((value, index) => value === selectedOptions[index])
      );
    }

    /**
     * Marks each option value unavailable (and disables its radio input, so
     * it truly can't be picked) when no in-stock variant exists for it
     * combined with whatever is currently selected for the other options.
     * Previously a customer could select any combination — including
     * sold-out ones — and only discover it was unavailable from the "Sold
     * out" text further down the page, after they'd already assumed the
     * item they picked was purchasable.
     */
    updateOptionAvailability() {
      const selectedOptions = this.getSelectedOptions();

      this.querySelectorAll('[data-option-index]').forEach((fieldset) => {
        const optionIndex = parseInt(fieldset.dataset.optionIndex, 10);

        fieldset.querySelectorAll('[data-option-input]').forEach((input) => {
          const hypothetical = selectedOptions.slice();
          hypothetical[optionIndex] = input.value;

          const available = this.productData.variants.some(
            (variant) =>
              variant.available &&
              variant.options.every((value, index) => hypothetical[index] === undefined || value === hypothetical[index])
          );

          input.disabled = !available;
          const label = fieldset.querySelector(`label[for="${input.id}"]`);
          label?.classList.toggle('is-unavailable', !available);
        });
      });
    }

    onOptionChange() {
      const selectedOptions = this.getSelectedOptions();
      const variant = this.findMatchingVariant(selectedOptions);
      this.updateOptionAvailability();

      this.querySelectorAll('[data-option-index]').forEach((fieldset) => {
        const selectedInput = fieldset.querySelector('[data-option-input]:checked');
        const label = fieldset.querySelector('[data-selected-value]');
        if (selectedInput && label) label.textContent = selectedInput.value;
      });

      if (!variant) {
        this.addToCartBtn.disabled = true;
        if (this.addToCartText) this.addToCartText.textContent = window.themeStrings.soldOut;
        return;
      }

      this.idInput.value = variant.id;

      if (variant.featured_media) {
        this.setActiveMedia(String(variant.featured_media.id));
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      this.addToCartBtn.disabled = !variant.available;
      if (this.addToCartText) {
        this.addToCartText.textContent = variant.available ? window.themeStrings.addToCart : window.themeStrings.soldOut;
      }
      if (this.inventoryEl) {
        this.inventoryEl.classList.toggle('is-sold-out', !variant.available);
        this.inventoryEl.textContent = variant.available ? window.themeStrings.inStock : window.themeStrings.soldOut;
      }

      document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant } }));
    }

    async onSubmit(event) {
      if (document.body.dataset.cartType !== 'drawer') return;

      event.preventDefault();
      this.addToCartBtn.disabled = true;
      const formData = new FormData(this.form);

      try {
        await Theme.cart.add(formData);
        document.dispatchEvent(new CustomEvent('cart:open'));
      } catch (error) {
        // Errors already broadcast via the cart:error event.
      } finally {
        this.addToCartBtn.disabled = false;
      }
    }
  }

  if (!customElements.get('product-page')) {
    customElements.define('product-page', ProductPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["racquet-finder-quiz"] && !Shopify.designMode) return;
  try {
    
  class RacquetFinderQuiz extends HTMLElement {
    connectedCallback() {
      this.panels = Array.from(this.querySelectorAll('[data-quiz-panel]'));
      this.progressSteps = Array.from(this.querySelectorAll('[data-progress-step]'));
      this.resultsLink = this.querySelector('[data-quiz-results-link]');
      this.budgetMinInput = this.querySelector('[data-budget-min]');
      this.budgetMaxInput = this.querySelector('[data-budget-max]');
      this.collectionUrl = this.dataset.collectionUrl;
      this.levelPrefix = this.dataset.levelPrefix || 'Level_';
      this.stylePrefix = this.dataset.stylePrefix || 'Feature_';
      this.answers = {};

      this.querySelectorAll('[data-quiz-answer]').forEach((button) => {
        button.addEventListener('click', () => this.onAnswer(button));
      });

      this.querySelectorAll('[data-quiz-back]').forEach((button) => {
        button.addEventListener('click', () => this.goToPanel(1));
      });

      this.querySelectorAll('[data-quiz-back-to]').forEach((button) => {
        button.addEventListener('click', () => this.goToPanel(parseInt(button.dataset.quizBackTo, 10)));
      });

      this.querySelectorAll('[data-quiz-see-matches], [data-quiz-skip-budget]').forEach((button) => {
        button.addEventListener('click', () => {
          this.buildResultsLink();
          this.goToPanel(4);
        });
      });

      this.querySelectorAll('[data-quiz-restart]').forEach((button) => {
        button.addEventListener('click', () => {
          this.answers = {};
          if (this.budgetMinInput) this.budgetMinInput.value = '';
          if (this.budgetMaxInput) this.budgetMaxInput.value = '';
          this.goToPanel(1);
        });
      });
    }

    onAnswer(button) {
      const question = button.dataset.quizAnswer;
      const value = button.dataset.value;
      this.answers[question] = value;

      if (question === 'level') {
        this.goToPanel(2);
      } else if (question === 'style') {
        this.goToPanel(3);
      }
    }

    buildResultsLink() {
      if (!this.resultsLink) return;
      const url = new URL(this.collectionUrl, window.location.origin);
      if (this.answers.level) {
        url.searchParams.append('filter.p.tag', `${this.levelPrefix}${this.answers.level}`);
      }
      if (this.answers.style) {
        url.searchParams.append('filter.p.tag', `${this.stylePrefix}${this.answers.style}`);
      }
      const min = this.budgetMinInput?.value;
      const max = this.budgetMaxInput?.value;
      if (min) url.searchParams.set('filter.v.price.gte', min);
      if (max) url.searchParams.set('filter.v.price.lte', max);
      this.resultsLink.href = url.pathname + url.search;
    }

    goToPanel(panelNumber) {
      this.panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.quizPanel === String(panelNumber));
      });
      this.progressSteps.forEach((step, i) => {
        const stepNumber = i + 1;
        step.classList.toggle('is-active', stepNumber === panelNumber);
        step.classList.toggle('is-complete', stepNumber < panelNumber);
      });
    }
  }

  if (!customElements.get('racquet-finder-quiz')) {
    customElements.define('racquet-finder-quiz', RacquetFinderQuiz);
  }

  } catch(e) { console.error(e); }
})();
})();
